import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

export default () => {
  const presenter = useLocalStore(() => ({
    get isOfflineNetworkStatus() {
      return Entities.App.isOfflineNetworkStatus;
    },
  }));

  return presenter;
};
